import type { PropsWithChildren } from 'react'

import type { AlertProps } from '@mui/material/Alert'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'

import type { Styles } from '../../theme/types/Styles'

export { StyledAlert }

type Props = PropsWithChildren<{
  severity?: AlertProps['severity']
  title?: string
  sx?: Styles
}>

const StyledAlert = ({ severity = 'warning', title, children, sx }: Props) => {
  return (
    <Alert severity={severity} sx={{ mb: 2, ...sx }}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </Alert>
  )
}
